import React, { memo, useState } from 'react';
import { Button, Fade, Paper, Popper, withStyles } from '@material-ui/core';
import styles from './styles';
import { RefreshOutlined, ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { REVERT_COLUMNS } from '../../../components/modules/IBPlanning/ShipmentsView/constant';

const Revert = ({ classes, eventHub, headerId }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  const closePopover = () => {
    setAnchorEl(null);
  };

  const handleRevert = (field) => () => {
    eventHub.emit(`${headerId}_revertData`, field);
  };

  return (
    <div
      onMouseLeave={handleMouseLeave}
      className={`${classes.headerIconStyles} ${classes.iconLayout}`}>
      <div className={classes.revertContainer} onMouseEnter={handleMouseEnter}>
        <RefreshOutlined className={classes.revertIcon} /> <ExpandMoreIcon />
      </div>
      <Popper
        id="messages"
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={closePopover}
        transition
        className={classes.customPopper}
        placement="bottom">
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper className={classes.menuContainer}>
              <Button
                onClick={handleRevert(REVERT_COLUMNS.APT_WINDOW)}
                className={classes.menuLabel}>
                Revert APT Window
              </Button>
              <Button onClick={handleRevert(REVERT_COLUMNS.IBETA)} className={classes.menuLabel}>
                Revert IB ETA
              </Button>
              <Button
                onClick={handleRevert(REVERT_COLUMNS.FROZEN_PALLETS)}
                className={classes.menuLabel}>
                Revert Frozen Pallets
              </Button>
              <Button
                onClick={handleRevert(REVERT_COLUMNS.NON_FROZEN_PALLETS)}
                className={classes.menuLabel}>
                Revert Non-Frozen Pallets
              </Button>
            </Paper>
          </Fade>
        )}
      </Popper>
    </div>
  );
};

export default withStyles(styles)(memo(Revert));
